<template>
    <div class="modal-mask" @click="$emit('fecharModal')">
        <div class="jm margem" style="min-width: 30vw;" @click.stop>
            <div class="alinha-centro">
                <h2>Iniciar Sprint</h2>
            </div>
            <br>
            <div :class="sprint.dtTermino? 'grid-2' : 'grid-1'">
                <div v-if="sprint.dtInicio">
                    <label>Data prevista de inicio</label>
                    <input v-model="sprint.dtInicio" type="date">
                </div>
                <div>
                    <label>Data prevista de termino</label>
                    <input v-model="sprint.dtTermino" type="date">
                </div>
            </div>
            <div class="submit m-b direita">
                <button @click="iniciarSprint" :disabled="!sprint.dtTermino">
                    Salvar</button>
            </div>
        </div>
    </div>
</template>

<script>
import serviceProjetos from '@/services/serviceProjetos'
export default {
    name: 'ModalIniciarSprint',

    props: {
        propSprint: {
            required: true
        },
    },
    data() {
        return {
            sprint: this.propSprint
        }
    },
    mounted() {
        this.sprint.dtInicio = this.sprint.dtInicio?.split(' ')[0] ?? null;
        this.sprint.dtTermino = this.sprint.dtTermino?.split(' ')[0] ?? null;

    },
    methods: {
        async iniciarSprint() {
            var data = new Date().toISOString().split('T')[0]
            var payload = {}

            if (!this.sprint.dtInicio && this.sprint.dtTermino) {
                this.sprint.dtInicio = data
                payload = {
                    dtInicio: data,
                    dtTermino: this.sprint.dtTermino,
                }
            } else {
                payload = {
                    dtInicio: this.sprint.dtInicio,
                    dtTermino: this.sprint.dtTermino,
                }
            }

            await serviceProjetos.atualizarSprint(this.sprint.id, payload);
            this.$emit('atualizarSprint')
        },
    },
}
</script>

<style scoped></style>